export const PROVIDER_AGREEMENTS = [
  {
    type: "PROVIDER_SERVICE",
    title: "图π服务者协议",
    version: "2026-07-01",
    sections: [
      {
        title: "一、服务者身份",
        content: "服务者应使用真实、有效的身份信息完成平台认证，并保证提交的作品、案例与服务能力说明真实准确。",
      },
      {
        title: "二、服务履约",
        content: "服务者应按照订单约定的范围、交付时间和质量标准完成设计服务；需求变更应通过平台订单或沟通记录确认。",
      },
      {
        title: "三、原创与授权",
        content: "服务者应确保交付内容不侵犯第三方著作权、商标权、肖像权及其他合法权益，并按照订单约定完成相应使用权授权。",
      },
      {
        title: "四、平台规则",
        content: "服务者同意遵守平台关于交易、评价、内容审核、争议处理和违规处置的规则，不得绕过平台实施欺诈或虚假交易。",
      },
      {
        title: "五、协议留痕",
        content: "点击同意后，平台将记录协议类型、版本、正文摘要、签署时间及必要的安全审计信息。",
      },
    ],
  },
  {
    type: "PAYMENT_SETTLEMENT",
    title: "图π支付结算协议",
    version: "2026-07-01",
    sections: [
      {
        title: "一、结算账户",
        content: "服务者应绑定与实名认证主体一致的有效结算账户，并确保账户状态正常、信息真实准确。",
      },
      {
        title: "二、收入结算",
        content: "平台依据订单履约、验收、退款及争议处理结果计算可结算金额，具体到账时间以支付机构处理结果为准。",
      },
      {
        title: "三、退款与调整",
        content: "发生退款、争议裁决、异常交易或计算差错时，平台可按照订单事实和平台规则调整待结算或后续结算金额。",
      },
      {
        title: "四、安全与合规",
        content: "服务者不得出租、出借结算账户，不得利用平台从事洗钱、套现、虚假交易或其他违法违规活动。",
      },
      {
        title: "五、信息变更",
        content: "结算账户或主体信息发生变化时，服务者应及时更新并重新完成必要的验证流程。",
      },
    ],
  },
];

function getAgreementDigestSource(agreement) {
  const body = agreement.sections
    .map((section) => `${section.title}\n${section.content}`)
    .join("\n\n");
  return `${agreement.type}\n${agreement.version}\n${agreement.title}\n\n${body}`;
}

export async function createAgreementAcceptancePayload(agreement) {
  const source = new TextEncoder().encode(getAgreementDigestSource(agreement));
  const digestBuffer = await globalThis.crypto.subtle.digest("SHA-256", source);
  const contentDigest = Array.from(new Uint8Array(digestBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  return {
    agreement_type: agreement.type,
    agreement_version: agreement.version,
    content_digest: contentDigest,
  };
}
